var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgStocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 19C85.5523 19 86 19.4477 86 20V24H92C93.1046 24 94 24.8954 94 26V48C94 49.1046 93.1046 50 92 50H86V54C86 54.5523 85.5523 55 85 55C84.4477 55 84 54.5523 84 54V50H78C76.8954 50 76 49.1046 76 48V26C76 24.8954 76.8954 24 78 24H84V20C84 19.4477 84.4477 19 85 19Z",
    fill: "#3A8761"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 34C62.5523 34 63 34.4477 63 35V39H69C70.1046 39 71 39.8954 71 41V63C71 64.1046 70.1046 65 69 65H63V69C63 69.5523 62.5523 70 62 70C61.4477 70 61 69.5523 61 69V65H55C53.8954 65 53 64.1046 53 63V41C53 39.8954 53.8954 39 55 39H61V35C61 34.4477 61.4477 34 62 34Z",
    fill: "#D6E8F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 5C39.5523 5 40 5.44772 40 6V10H46C47.1046 10 48 10.8954 48 12V34C48 35.1046 47.1046 36 46 36H40V40C40 40.5523 39.5523 41 39 41C38.4477 41 38 40.5523 38 40V36H32C30.8954 36 30 35.1046 30 34V12C30 10.8954 30.8954 10 32 10H38V6C38 5.44772 38.4477 5 39 5Z",
    fill: "#3A8761"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21C16.5523 21 17 21.4477 17 22V26H23C24.1046 26 25 26.8954 25 28V50C25 51.1046 24.1046 52 23 52H17V56C17 56.5523 16.5523 57 16 57C15.4477 57 15 56.5523 15 56V52H9C7.89543 52 7 51.1046 7 50V28C7 26.8954 7.89543 26 9 26H15V22C15 21.4477 15.4477 21 16 21Z",
    fill: "#D6E8F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28C25 26.8954 24.1046 26 23 26H17V52H23C24.1046 52 25 51.1046 25 50V28Z",
    fill: "#B0D2EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71 41C71 39.8954 70.1046 39 69 39H63V65H69C70.1046 65 71 64.1046 71 63V41Z",
    fill: "#B0D2EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 12C48 10.8954 47.1046 10 46 10H40V36H46C47.1046 36 48 35.1046 48 34V12Z",
    fill: "#056837"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26C94 24.8954 93.1046 24 92 24H86V50H92C93.1046 50 94 49.1046 94 48V26Z",
    fill: "#056837"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80.5L63.5244 95.0155C62.6596 95.574 61.5121 95.3848 60.8724 94.5782L40.2296 68.5504C39.5484 67.6915 38.3027 67.541 37.4366 68.213L10 89.5",
    stroke: "#2874B1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75L87.5 89.5L95.5 74L78 75Z",
    fill: "#2874B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStocks);
export default __webpack_public_path__ + "static/media/imgStocks.517a413baad5ac543934824ba2cc6f75.svg";
export { ForwardRef as ReactComponent };